import React from 'react';
import { RoutePermittedRole } from '@crema/constants/AppEnums';



import Loading from '@libs/modules/src/lib/errorPages/Loading';

const ChannelCommonInfo = React.lazy(() => import('../../modules/channelCommonInfo'));
const CommonInfoList = React.lazy(() => import('../../modules/channelCommonInfo/list'));
const CommonInfoRegistration = React.lazy(() => import('../../modules/channelCommonInfo/registration'));
const ProductTheme = React.lazy(() => import('../../modules/productTheme'));
const ThemeList = React.lazy(() => import('../../modules/productTheme/list'));
const ThemeRegistration = React.lazy(() => import('../../modules/productTheme/registration'));
const ChannelProduct = React.lazy(() => import('../../modules/productManagement'));
const ChannelProductRegistration = React.lazy(() => import('../../modules/productManagement/registration'));
const ChannelProductSelect = React.lazy(() => import('../../modules/productManagement/select'));
const ChannelProductList = React.lazy(() => import('../../modules/productManagement/list'));
const SalesProductList = React.lazy(() => import('../../modules/productManagement/salesProducts/SalesProductList'));
const SalesProductDetail = React.lazy(() => import('../../modules/productManagement/salesProducts/SalesProductDetail'));
const ChannelProductCategoryList = React.lazy(() => import('../../modules/productManagement/ChannelProductCategoryType/List'));
const ChannelProductCategoryDetail = React.lazy(() => import('../../modules/productManagement/ChannelProductCategoryType/Detail'));
export const productManagementConfigs = [
  {
    permittedRole: RoutePermittedRole.User,
    path: '/channelProducts',
    children: [
      {
        path: '',
        element: <ChannelProductList />,
      },
      {
        path: 'list',
        element: <ChannelProductList />,
      },
      {
        path: 'registration',
        element: <ChannelProductRegistration />,
      },
      {
        path: 'select',
        element: <ChannelProductSelect />,
      },
    ],
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/channelProductsCommonInfo/*',
    element: <ChannelCommonInfo />,
    children: [
      {
        path: '',
        element: <CommonInfoList />,
      },
      {
        path: 'registration',
        element: <CommonInfoRegistration />,
      },
    ],
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/channelProductThemeManagement',
    element: <ProductTheme />,
    children: [
      {
        path: '',
        element: <ThemeList />,
      },
      {
        path: 'registration',
        element: <ThemeRegistration />,
      },
    ],
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/product/sales',
    element: <SalesProductList />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/product/sales/detail',
    element: <SalesProductDetail />,
  },

  {
    permittedRole: RoutePermittedRole.User,
    path: '/channelProductsCategory',
    children: [
      {
        path: '',
        element: <ChannelProductCategoryList />,
      },
      {
        path: ':id',
        element: <ChannelProductCategoryDetail />,
      },
    ],
  },
  // {
  //   path: '/loading',
  //   element: <Loading />,
  // },
];
